/**
 * Normalize any user-entered phone number to AU E.164 (always +61 prefixed)
 * before sending to the API. No format validation — accepts whatever the user
 * types and just guarantees a single +61 country code.
 *   "0412345678"  -> "+61412345678"
 *   "412345678"   -> "+61412345678"
 *   "61412345678" -> "+61412345678"
 *   "+61412..."   -> unchanged
 */
export function formatAuPhone(phone) {
  const raw = `${phone || ""}`.replace(/[\s\-()]/g, "");
  if (!raw) return raw;
  if (raw.startsWith("+")) return raw;
  if (raw.startsWith("0")) return `+61${raw.slice(1)}`;
  if (raw.startsWith("61")) return `+${raw}`;
  return `+61${raw}`;
}
